export const ERROR_CODE = {
  ERR_NETWORK: 'ERR_NETWORK',
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
};

/**
 * Shown when login is blocked because the account was pre-created by a workspace invitation
 * that was never accepted. Self-serve signups are approved automatically, so this state only
 * ever means "invited, never joined" — the old "pending approval" wording sent people to
 * support for an approval no one could grant.
 */
export const INVITATION_NOT_ACTIVE_MESSAGE =
  'Your invitation to MarketBetter is no longer active. Ask your workspace admin to invite you again, or contact support@marketbetter.ai';
